import AllowedActions from './AllowedActions';

export default AllowedActions;
